const onePoundKg = 0.453592;
const oneMileKm = 1.609344;
const inchToCm = 2.54;

export function poundToKg(lbs) {
    return parseFloat((lbs * onePoundKg).toFixed(1));
}

export function mileToKm(mile = 0) {
    return parseFloat(mile * oneMileKm).toFixed(1);
}

export function kmToMile(km = 0) {
    return parseFloat((km / oneMileKm).toFixed(1));
}

export function heightToCm(units) {
    return parseFloat(units * inchToCm).toFixed(1);
}

export function heightToFeetInches(height) {
    return `${Math.floor(height / 12)}' ${height % 12}"`;
}

export function metersToMiles(meters) {
    return parseFloat(meters / (oneMileKm * 1000)).toFixed(1);
}

export function milesToMeters(mile) {
    return parseFloat((mile * oneMileKm) * 1000).toFixed(1);
}

export function metersToKm(meters) {
    return parseFloat(meters / 1000).toFixed(1);
}

export function paceMileToMph(paceMileSeconds) {
    return parseFloat((1 / paceMileSeconds) * 3600).toFixed(1);
}

export default {
    poundToKg,
    mileToKm,
};



/** WEBPACK FOOTER **
 ** ./src/utils/convertUnits.js
 **/